import axios from 'axios'

export const VERSION = 'v4.0.60';

const http = axios.create({
    baseURL: `${window.location.protocol}//${window.location.hostname}:2083`,
    //baseURL: `http://backup.eventscoded.com:4004`,
    headers: {
        'Authorization': `Bearer ${localStorage.token}`
    }
})

http.interceptors.request.use(config => {
    config.headers['X-Client-Version'] = VERSION
    return config;
  }, error => {
    return Promise.reject(error);
});

export default http
